export default __webpack_public_path__ + "static/card-5-4c70fbc9ae560698022466adf923a689.svg";